import React, { useEffect, useState } from 'react';
import { BiSearchAlt2, BiX } from 'react-icons/bi'
import '../assests/css/dashboard.css'

function SearchBar({ handleSearchChange, category ,emptygroup }) {

    const [item, setItem] = useState('');

    useEffect(() => {
        // console.log("category in search bar", category)
    }, [handleSearchChange, item]);

    useEffect(() => {
     //   handleValue('')
    }, [category,emptygroup])

    const handleValue = (x) => {
        var desired = x.replace(/[^\w-\s]/gi, '')
        handleSearchChange(desired);
        
        setItem(desired);
        localStorage.setItem('searchItem',desired)
        
    }

   
//console.log("------------------")
    return (
        <div className="searchBarStyle">
            <small>
                <BiSearchAlt2 color="grey" size="20px" />
                <input
                    className="searchInput"
                    type="text"
                    value={item}
                    placeholder="Search Result By Customer Name & Address"
                    style={{ border: "none !important", width: "94%" }}
                    onChange={(e) => handleValue(e.target.value)}
                />
                <span style={{ display: item.length === 0 ? "none" : '' , cursor: 'pointer'}}>
                    <BiX color="grey" size="25px" onClick={() => handleValue('')} />
                </span>
            </small>
        </div>
    );
}

export default SearchBar;